<template>
    <div style="width: 100%">
        <!-- desktop view -->
        <v-col v-if="!$vuetify.breakpoint.smAndDown" cols="12">
            <v-toolbar flat style="background-color: transparent" class="mt-1 d-flex justify-center">
                <div class="d-flex align-center">
                    <v-btn depressed v-if="hasAdminPermission" class="overline mr-md-2" color="red darken-3" dark
                        @click="openSummaryTeams()">
                        Equipos
                        <v-icon right>mdi-account-group</v-icon>
                        <TeamsSummary />
                    </v-btn>
                    <v-btn depressed v-if="hasManagerPermission" class="overline mr-md-2" color="pink" dark
                        @click="openSummaryCorrectiveFactor()">
                        Factor Corrector
                        <v-icon right>mdi-archive-plus-outline</v-icon>
                        <CorrectiveFactorSummary />
                    </v-btn>
                    <v-btn
                        class="overline white--text"
                        color="#2c3a5c"
                        @click="thisMonth"
                        :disabled="isLoadingObjetivos || isLoadingOfertas"
                        depressed
                    >
                        Este mes
                        <v-icon right>mdi-calendar</v-icon>
                    </v-btn>
                    <v-btn depressed fab text small color="grey darken-2"
                        :disabled="isLoadingObjetivos || isLoadingOfertas" @click="prev">
                        <v-icon small> mdi-chevron-left </v-icon>
                    </v-btn>
                    <v-toolbar-title v-if="isExporting" class="overline mx-3">
                        <h3 class="d-flex justify-center mb-n3">{{ getPercentage() }}</h3>
                        <h5 class="d-flex justify-center my-n3 grey--text">{{ getTime() }}</h5>
                    </v-toolbar-title>
                    <v-toolbar-title v-else class="overline">
                        <h3>{{ currentNameMonthYear }}</h3>
                    </v-toolbar-title>
                    <v-btn fab depressed text small :disabled="isLoadingObjetivos || isLoadingOfertas"
                        color="grey darken-2" @click="next">
                        <v-icon small> mdi-chevron-right </v-icon>
                    </v-btn>
                    <v-btn depressed v-if="
                            hasManagerPermission ||
                            isDownloadCalculadoraComercial
                        " dark class="overline" color="blue darken-1" @click="download">
                        Descargar
                        <v-icon right>mdi-download</v-icon>
                    </v-btn>
                    <v-btn depressed v-if="hasManagerPermission" class="overline ml-md-2" color="green darken-1" dark
                        @click="
                            isOpenDownloadTemplateAndUpload = true;
                            uploadMessage =
                                'subir el archivo con los objetivos del mes';
                            uploadAction = 'Subiendo';
                            title = 'Subir objetivos';
                            templateMutationPath =
                                'gerencia/download_objectives_template';
                            submitPath = 'import_objectives_xlsx';
                            multiple = false;
                        ">
                        Subir Objetivos
                        <v-icon right>mdi-bullseye-arrow</v-icon>
                    </v-btn>
                    <v-btn depressed v-if="hasAdminPermission" @click="openSummaryBadgeTable()" class="overline ml-md-2"
                        color="green accent-3" dark>Bonificación
                        <v-icon right>mdi-playlist-star</v-icon>
                        <MoneyBagSummary />
                    </v-btn>
                </div>
            </v-toolbar>
            <v-progress-linear v-if="isExporting && hasManagerPermission" :value="exportingProgress"
                :indeterminate="exportingProgress == 0" height="4" color="#4CAF50" background-color="grey lighten-2">
            </v-progress-linear>
        </v-col>

        <!-- Mobile view -->
        <v-col v-else no-gutters cols="12">
            <v-progress-linear v-if="isExporting" :value="exportingProgress" class="mb-n1"></v-progress-linear>
            <v-toolbar class="mt-1 d-flex justify-center" style="z-index: 2 !important">
                <div class="d-flex align-center">
                    <v-speed-dial v-if="hasManagerPermission" v-model="fab" :open-on-hover="false" direction="bottom"
                        transition="slide-y-transition">
                        <template v-slot:activator>
                            <v-btn v-model="fab" icon>
                                <v-icon large v-if="fab"> mdi-close </v-icon>
                                <v-icon v-else large>
                                    mdi-dots-vertical
                                </v-icon>
                            </v-btn>
                        </template>

                        <v-btn v-if="hasManagerPermission" fab small class="overline mr-md-2" color="red darken-3" dark
                            @click="openSummaryTeams()">
                            <v-icon small>mdi-account-group</v-icon>
                        </v-btn>
                        <v-btn v-if="hasManagerPermission" class="overline mr-md-2" color="pink" fab small dark
                            @click="openSummaryCorrectiveFactor()">
                            <v-icon small>mdi-archive-plus-outline</v-icon>
                        </v-btn>
                        <v-btn fab small class="overline" color="primary" @click="thisMonth"
                            :disabled="isLoadingObjetivos || isLoadingOfertas">
                            <v-icon small>mdi-calendar</v-icon>
                        </v-btn>
                    </v-speed-dial>
                    <div v-if="hasManagerPermission">
                        <MoneyBagSummary />
                        <TeamsSummary />
                    </div>
                    <v-btn v-if="!hasManagerPermission" fab small class="overline" color="primary" @click="thisMonth"
                        :disabled="isLoadingObjetivos || isLoadingOfertas">
                        <v-icon small>mdi-calendar</v-icon>
                    </v-btn>

                    <v-btn fab text small color="grey darken-2" :disabled="isLoadingObjetivos || isLoadingOfertas"
                        @click="prev">
                        <v-icon small> mdi-chevron-left </v-icon>
                    </v-btn>
                    <v-toolbar-title v-if="isExporting" class="overline mx-3">
                        <h3>{{ exportingProgress.toFixed(1) + ' %' }}</h3>
                    </v-toolbar-title>
                    <v-toolbar-title v-else class="overline">
                        <h3>{{ currentNameMonthYear }}</h3>
                    </v-toolbar-title>
                    <v-btn fab text small :disabled="isLoadingObjetivos || isLoadingOfertas" color="grey darken-2"
                        @click="next">
                        <v-icon small> mdi-chevron-right </v-icon>
                    </v-btn>

                    <v-speed-dial v-if="hasManagerPermission" v-model="fab1" :open-on-hover="false" direction="bottom"
                        transition="slide-y-transition">
                        <template v-slot:activator>
                            <v-btn v-model="fab1" icon>
                                <v-icon large v-if="fab1"> mdi-close </v-icon>
                                <v-icon v-else large>
                                    mdi-dots-vertical
                                </v-icon>
                            </v-btn>
                        </template>

                        <v-btn v-if="
                                hasManagerPermission ||
                                isDownloadCalculadoraComercial
                            " fab dark small class="overline" color="blue darken-1" @click="download">
                            <v-icon small>mdi-download</v-icon>
                        </v-btn>
                        <v-btn fab small class="overline ml-md-2" color="green darken-1" dark @click="
                                isOpenDownloadTemplateAndUpload = true;
                                uploadMessage =
                                    'subir el archivo con los objetivos del mes';
                                uploadAction = 'Subiendo';
                                title = 'Subir objetivos';
                                templateMutationPath =
                                    'gerencia/download_objectives_template';
                                submitPath = 'import_objectives_xlsx';
                                multiple = false;
                            ">
                            <v-icon small>mdi-bullseye-arrow</v-icon>
                        </v-btn>
                        <v-btn v-if="hasAdminPermission" @click="openSummaryBadgeTable()" fab small
                            class="overline ml-md-2" color="green accent-3" dark>
                            <v-icon small>mdi-playlist-star</v-icon>
                        </v-btn>
                    </v-speed-dial>
                    <div v-if="hasManagerPermission">
                        <CorrectiveFactorSummary />
                    </div>
                    <v-btn v-if="
                            !hasManagerPermission ||
                            isDownloadCalculadoraComercial
                        " fab dark small class="overline" color="blue darken-1" @click="download">
                        <v-icon small>mdi-download</v-icon>
                    </v-btn>
                </div>
            </v-toolbar>
        </v-col>

        <v-row no-gutters>
            <v-select v-if="$store.getters['login/hasManagerPermission']"
                :disabled="isLoadingObjetivos || isLoadingFetchComerciales" class="pa-4" :items="comerciales"
                v-model="selectedComercial" item-text="nombreCompleto" return-object prepend-inner-icon="mdi-account"
                hint="Selecciona un comercial para ver sus ofertas y objetivos" persistent-hint
                :menu-props="{ maxHeight: '600' }" label="Comercial" clearable>
                <template #item="{ item }">
                    <v-row>
                        <v-col cols="11">
                            {{ item.nombreCompleto }}
                        </v-col>
                        <v-col v-if="item.estado && !$vuetify.breakpoint.smAndDown" cols="1">
                            <v-chip label :color="estadoComercial[item.estado]" medium
                                class="d-flex justify-center overline">
                                {{ item.estado }}
                            </v-chip>
                        </v-col>
                        <v-col v-if="item.estado && $vuetify.breakpoint.smAndDown" cols="1">
                            <v-icon :color="estadoComercial[item.estado]" large class="d-flex justify-center overline">
                                mdi-circle
                            </v-icon>
                        </v-col>
                    </v-row>
                </template>
            </v-select>
        </v-row>

        <!-- Mobile view -->
        <v-row v-if="$vuetify.breakpoint.smAndDown" no-gutters>
            <v-col cols="12">
                <v-expansion-panels>
                    <v-expansion-panel class="pa-0">
                        <v-expansion-panel-header>
                            <p class="text-center overline">
                                Seguimiento de ofertas
                            </p>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content id="innerExPan">
                            <RegistroVentas :currentDate="currentDate" />
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel class="my-1">
                        <v-expansion-panel-header>
                            <p class="text-center overline">
                                Seguimiento de gestiones
                            </p>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content id="innerExPan">
                            <TablaGestiones :currentDate="currentDate" />
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel class="my-1" v-if="
                            (selectedComercial && hasManagerPermission) ||
                            hasComercialPermission
                        ">
                        <v-expansion-panel-header>
                            <p class="text-center overline">
                                Seguimiento de objetivos
                            </p>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content id="innerExPan">
                            <v-responsive>
                                <TablaObjetivos />
                                <TablaBolsa />
                                <v-btn :disabled="
                                        factor_corrector.length == 0 ||
                                        isLoadingObjetivos
                                    " width="100%" color="primary" x-large @click="openViewFactor">FACTOR CORRECTOR
                                </v-btn>
                                <CorrectiveFactorView />
                                <TablaLlave />
                            </v-responsive>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>

        <!-- Desktop view -->
        <v-row v-else class="mx-2">
            <v-col cols="12" md="12" :lg="
                    (!selectedComercial && !hasComercialPermission)
                        ? 12
                        : 6
                ">
                <RegistroVentas :currentDate="currentDate" />
                <TablaGestiones :currentDate="currentDate" class="mt-4" />
            </v-col>
            <v-col cols="12" md="12" :lg="
                    (hasComercialPermission && objetivo.length) ||
                    (hasManagerPermission && selectedComercial)
                        ? 6
                        : 6
                " v-if="
                    (selectedComercial && hasManagerPermission) ||
                    hasComercialPermission
                ">
                <v-row>
                    <v-col cols="12">
                        <TablaObjetivos />
                    </v-col>
                </v-row>
                <v-row class="mt-1">
                    <v-col cols="5">
                        <TablaBolsa />
                        <v-btn width="100%" :disabled="
                                factor_corrector.length == 0 ||
                                isLoadingObjetivos
                            " color="primary" x-large @click="openViewFactor">FACTOR CORRECTOR
                        </v-btn>
                        <CorrectiveFactorView />
                    </v-col>
                    <v-col cols="7" class="mb-1">
                        <TablaLlave />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <FormAtencion />
        <DownloadTemplateAndUpload :message="uploadMessage" :multiple="multiple" :title="title"
            :templateMutationPath="templateMutationPath" submitMutationPath="gerencia/importFiles"
            :submitPath="submitPath" datePicker="True" />
    </div>
</template>

<script>
import DownloadTemplateAndUpload from '@/components/DownloadTemplateAndUpload/DownloadTemplateAndUpload.vue';
import UploadForm from '@/components/UploadForm/UploadForm.vue';
import RegistroVentas from './RegistroVentas.vue';
import TablaObjetivos from './TablaObjetivos.vue';
import TablaLlave from './TablaLlave.vue';
import TablaBolsa from './TablaBolsa.vue';
import TablaGestiones from './TablaGestiones.vue';
import FormAtencion from '@/components/AreaPersonal/Calculadora/FormAtencion.vue';
import MoneyBagSummary from '@/components/AreaPersonal/Calculadora/BolsaFija/moneyBagSummary.vue';
import CorrectiveFactorSummary from '@/components/AreaPersonal/Calculadora/FactorCorrector/correctiveFactorSummary.vue';
import TeamsSummary from '@/components/AreaPersonal/Calculadora/Teams/teamsSummary.vue';
import CorrectiveFactorView from '@/components/AreaPersonal/Calculadora/FactorCorrector/correctiveFactorView.vue';

import { mapState, mapGetters, mapActions } from 'vuex';
import { estadoComercial, dateToISOString } from '@/util/libUtil.js';

export default {
    name: 'Calculadora',
    components: {
        DownloadTemplateAndUpload,
        UploadForm,
        RegistroVentas,
        TablaObjetivos,
        TeamsSummary,
        // FactorCorrector,
        CorrectiveFactorView,
        TablaLlave,
        TablaBolsa,
        TablaGestiones,
        FormAtencion,
        MoneyBagSummary,
        CorrectiveFactorSummary,
    },
    data: () => ({
        elapsed: 0,
        fab: 0,
        fab1: 0,
        submitPath: '',
        uploadMessage: '',
        isLoadingFetchComerciales: false,
        uploadAction: '',
        title: '',
        multiple: false,
        templateMutationPath: '',
        // isOpenObjectives: false,
        estadoComercial,
    }),
    created() {
        if (this.hasManagerPermission) {
            this.isLoadingFetchComerciales = true;
            this.$store.dispatch('teletrabajo/fetchComerciales').then(() => {
                if (!this.selectedComercial) {
                    this.selectedComercial = this.comerciales.find(
                        ({ id }) => id == this.cuenta.id
                    );
                }
                this.isLoadingFetchComerciales = false;
            });
        }
    },
    methods: {
        dateToISOString,
        formatTime(time) {
            let seconds = Math.floor((time / 1000) % 60);
            let minutes = Math.floor((time / (1000 * 60)) % 60);
            let hours = Math.floor((time / (1000 * 60 * 60)) % 24);

            return `${hours}h ${minutes}m ${seconds}s`;
        },
        getTime(){
            if(this.exportingProgress != 0 && !isNaN(this.exportingProgress)){
                let formattedTime = this.formatTime(
                    (new Date().getTime() - this.elapsed) * (100 - this.exportingProgress) / this.exportingProgress
                );
            
                return formattedTime;
            }

            return 'Calculando...';
        },
        getPercentage(){
            if(this.exportingProgress != 0 && !isNaN(this.exportingProgress)){
                return `${this.exportingProgress.toFixed(0)} %`;
            }

            return '0%';
        },
        openViewFactor() {
            this.$store.commit(
                'areaPersonal/calculadora/isOpenViewFactor',
                true
            );
        },
        openSummaryTeams() {
            this.$store.commit(
                'areaPersonal/calculadora/isOpenSummaryTeams',
                true
            );
        },
        openSummaryCorrectiveFactor() {
            this.$store.commit(
                'areaPersonal/calculadora/isOpenSummaryCorrectiveFactor',
                true
            );
        },
        openSummaryBadgeTable() {
            this.$store.commit(
                'areaPersonal/calculadora/isOpenSummaryBadgeTable',
                true
            );
        },
        convertDateToLocale(date) {
            return `${date.toLocaleString('es', {
                month: 'long',
                year: 'numeric',
            })}`;
        },
        submit() {
            // this.uploadMessage = "subir el archivo con los objetivos"
            this.uploadAction = 'Subiendo';
            this.$store.dispatch(
                'gerencia/importFiles',
                'import_objectives_xlsx'
            );
        },
        download() {
            this.$store.dispatch('areaPersonal/calculadora/exportDB');
        },
        thisMonth() {
            this.$store.commit('areaPersonal/calculadora/date', new Date());
        },
        prev() {
            const copy = this.currentDate;
            copy.setDate(0);
            // copy.setMonth(this.currentDate.getMonth() - 1, 1);
            this.currentDate = new Date(copy);
        },
        next() {
            const copy = this.currentDate;
            copy.setMonth(this.currentDate.getMonth() + 1, 1);
            this.currentDate = new Date(copy);
        },
        download_template() {
            this.uploadAction = 'Descargando';
            this.download_objectives_template();
            // this.$store.dispatch(
            //     'areaPersonal/calculadora/download_objectives_template'
            // );
        },
        ...mapActions('areaPersonal/calculadora', ['fetchObjetivo']),
        ...mapActions({
            download_objectives_template:
                'gerencia/download_objectives_template',
        }),
        updateReward(newValue) {
            if (this.hasManagerPermission && this.selectedComercial) {
                let params = {
                    commercial: this.selectedComercial.id,
                    created_on: `${this.currentDate.getFullYear()}-${
                        this.currentDate.getMonth() + 1
                    }`,
                };

                if (dateToISOString(newValue) >= this.dateActualInmutable) {
                    params = { ...params, is_active: true };
                }

                // this.$store.dispatch(
                //     'areaPersonal/calculadora/fetchRewardType',
                //     params
                // );
            } else if (this.hasComercialPermission) {
                let params = {
                    commercial: this.cuenta.id,
                    created_on: `${this.currentDate.getFullYear()}-${
                        this.currentDate.getMonth() + 1
                    }`,
                };

                if (dateToISOString(newValue) >= this.dateActualInmutable) {
                    params = { ...params, is_active: true };
                }

                // this.$store.dispatch(
                //     'areaPersonal/calculadora/fetchRewardType',
                //     params
                // );
            }
        },
    },
    computed: {
        cuenta() {
            return JSON.parse(localStorage.getItem('cuenta'));
        },
        tenantInfo() {
            return JSON.parse(localStorage.getItem('tenantInfo'));
        },
        // ...mapState('login', {
        //     cuenta: (state) => state.cuenta,
        // }),
        ...mapState('areaPersonal/calculadora', {
            objetivo: (state) => state.objetivo,
            objetivoComercial: (state) => state.objetivoComercial,
            selectedComercial: (state) => state.selectedComercial,
            isLoadingObjetivos: (state) => state.isLoadingObjetivos,
            factor_corrector: (state) => state.factor_corrector,
            isLoadingOfertas: (state) => state.isLoadingOfertas,
            rewardType: (state) => state.rewardType,
            dateActualInmutable: (state) => state.dateActualInmutable,
        }),
        ...mapState('teletrabajo', {
            comerciales: (state) => state.Comerciales,
            IsLoadingTtClienteDetails: (state) =>
                state.CompleteViewTtForm.details.isLoading,
        }),
        ...mapGetters('areaPersonal/calculadora', {
            currentNameMonthYear: 'currentNameMonthYear',
        }),
        ...mapGetters('login', {
            hasManagerPermission: 'hasManagerPermission',
            hasComercialPermission: 'hasComercialPermission',
            hasAdminPermission: 'hasAdminPermission',
        }),
        ...mapState('util', {
            exportingProgress: (state) => state.exportingProgress,
            isExporting: (state) => state.isExporting,
        }),
        isDownloadCalculadoraComercial() {
            let date = new Date();
            let prevDate = new Date();
            prevDate.setDate(1);
            prevDate.setMonth(date.getMonth() - 1);

            return (
                this.hasComercialPermission &&
                (this.currentNameMonthYear === this.convertDateToLocale(date) ||
                    this.currentNameMonthYear ===
                        this.convertDateToLocale(prevDate))
            );
        },
        isOpenDownloadTemplateAndUpload: {
            get() {
                return this.$store.state.util.isOpenDownloadTemplateAndUpload;
            },
            set(val) {
                this.$store.commit('util/isOpenDownloadTemplateAndUpload', val);
            },
        },
        selectedComercial: {
            get() {
                return this.$store.state.areaPersonal.calculadora
                    .selectedComercial;
            },
            set(val) {
                this.$store.commit(
                    'areaPersonal/calculadora/selectedComercial',
                    val
                );
            },
        },
        currentDate: {
            get() {
                return this.$store.state.areaPersonal.calculadora.date;
            },
            set(val) {
                this.$store.commit('areaPersonal/calculadora/date', val);
            },
        },
    },
    watch: {
        selectedComercial: {
            immediate: true,
            handler(newValue, oldValue) {
                if (this.selectedComercial)
                    this.fetchObjetivo({
                        comercialId: this.selectedComercial.id,
                    });
                else
                    this.$store.commit(
                        'areaPersonal/calculadora/objetivoComercial',
                        []
                    );
            },
        },
        currentDate: {
            immediate: true,
            handler: function (newValue, oldValue) {
                this.updateReward(newValue);
                if (this.selectedComercial)
                    this.fetchObjetivo({
                        comercialId: this.selectedComercial.id,
                    });

                if (this.hasComercialPermission) {
                    this.fetchObjetivo({});
                }
            },
        },
        isExporting(val) {
            if (val) {
                this.elapsed = new Date().getTime();
            }
        },
    },
};
</script>

<style>
#innerExPan > * {
    /* padding-top: 0px;
        padding-right: 0px;
        padding-bottom: 0px;
        padding-left: 0px; */
}
.v-expansion-panel-content__wrap {
    /* padding: 0 !important; */
}
</style>